import { PURCHASE_REQUEST_AUDITS_CRUD_ACTION_CREATORS } from '../actions/purchase_request_audits_actions';
import { logoutSuccess } from '../actions/session_actions';
import { getBackendUri } from '../utils/EnvConfigUtils';
import FetchUtils, { parseJSON } from './fetch_utils';

const fetchUtils = new FetchUtils();
const BASE_URL = getBackendUri();

export const fetchPurchaseRequestAudits = (
	purchaseRequestId,
	targetCollectionName = null,
	pagination = null,
	sorting = null,
	filters = null
) => {
	const apiUrl = `/api/v1/supplier/inventory/purchase_requests/${purchaseRequestId}/audits`;

	let params: any = {};

	if (pagination) {
		params.offset = (pagination.current - 1) * pagination.pageSize;
		params.limit = pagination.pageSize;
	}

	if (sorting) {
		params.sort_by = sorting.sort_by;
		params.order = sorting.order === 'ascend' || sorting.order === 'asc' ? 'asc' : 'desc';
	}

	if (filters) {
		params = { ...params, ...filters };
	}

	return (dispatch) => {
		dispatch(PURCHASE_REQUEST_AUDITS_CRUD_ACTION_CREATORS.fetchStart(targetCollectionName));

		return fetchUtils
			.get(
				BASE_URL + apiUrl,
				Object.assign(
					{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
					params
				)
			)
			.then(parseJSON)
			.then(({ json, status }) => {
				if (status === 401) {
					dispatch(logoutSuccess());
					return;
				}
				const d = json;
				if (d.status === 'error') {
					dispatch(
						PURCHASE_REQUEST_AUDITS_CRUD_ACTION_CREATORS.fetchError(d.message, targetCollectionName)
					);
				} else {
					dispatch(
						PURCHASE_REQUEST_AUDITS_CRUD_ACTION_CREATORS.fetchSuccess(
							d.data,
							d.count,
							targetCollectionName,
							{ ...pagination, total: d.count },
							sorting,
							filters
						)
					);
				}
			})
			.catch((err) => {
				dispatch(
					PURCHASE_REQUEST_AUDITS_CRUD_ACTION_CREATORS.fetchError(err.message, targetCollectionName)
				);
			});
	};
};
